import React from "react";
import {
  IonCol,
  IonRow,
  IonItem,
  IonIcon,
  IonLabel,
} from "@ionic/react";
import { wifi } from "ionicons/icons";


export const NoConnectionMsg: React.FC = () => {
    return (
        <React.Fragment>
            <IonRow >
                <IonCol>
                <IonItem color="danger">
                    <IonIcon icon={wifi} slot="start"></IonIcon>
                        <IonLabel className="ion-text-wrap">No Internet Connection - Please check your connection and try again.</IonLabel>
                    </IonItem>
                </IonCol>
            </IonRow>
        </React.Fragment>
    )
};


